import React from 'react';
import Title from './components/Title/Title';
import HtmlParser from 'react-html-parser';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import styles from '../../styles/rightAlign.terms.module.scss';
import {
  Checkbox,
  FormControlLabel,
  LinearProgress,
  Stack,
} from '@mui/material';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import useHandleInitialStepLogic from '../../Hooks/useHandleInitialStepLogic';

const Terms = ({
  config,
  setAcceptTerms,
  acceptTerms,
  data,
}) => {
  const { title, pageConfig } = config;

  const checkboxContent = FindLangKey(
    'get-new-turn-check-accept-terms'
  );

  useHandleInitialStepLogic(data);

  return (
    <Stack
      sx={{
        border: '1px solid gray',
        padding: '.5em',
        borderRadius: '.3em',
        gap: '.5em',
      }}
    >
      <Title title={title} />

      {!pageConfig ? (
        <LinearProgress />
      ) : (
        <div className={styles.termsContainer} dir="rtl">
          {HtmlParser(
            ArabicToPersian(pageConfig?.nobatAgreementRule)
          )}
        </div>
      )}

      <FormControlLabel
        dir="rtl"
        control={
          <Checkbox
            color="colorPrimer"
            sx={{ pr: 0, mr: 0 }}
            onChange={(event, value) => {
              setAcceptTerms(value);
            }}
            checked={acceptTerms}
          />
        }
        label={checkboxContent}
      />
    </Stack>
  );
};

export default Terms;
